import Head from 'next/head';
import React, { useContext } from 'react';
import { ProfileContext } from 'application/adapters/context/Profile';

export interface OrttoTrackingCodeProps {
	orttoTrackingKey: string;
	trackableDomains: string[];
}

export const OrttoTrackingCode: React.FC<OrttoTrackingCodeProps> = (props) => {
	const profileContext = useContext(ProfileContext);
	const profile = profileContext.profile;

	if (!props.orttoTrackingKey) return null;

	// Don't track the Cludo crawler as a visitor (backend sets membership.id to 'crawler' for its synthetic profile)
	if (profile?.membership?.id === 'crawler') return null;

	const trackingCode = `
    window.ap3c = window.ap3c || {};
    var ap3c = window.ap3c;
    ap3c.cmd = ap3c.cmd || [];
    ap3c.cmd.push(function() {
        ap3c.init('${props.orttoTrackingKey}', 'https://capture-api-eu.ortto.app/' ${
		props.trackableDomains && props.trackableDomains.length > 0 ? `, {cookieDomains: ['${props.trackableDomains.join("', '")}']}` : ''
	});
        ap3c.track({ ac: [{ 'fi': 'str:cm:membership-id', 'v':'${profile?.membership?.id || ''}' }]});
    });
    ap3c.activity = function(act) { ap3c.act = (ap3c.act || []); ap3c.act.push(act); };
    var s, t; s = document.createElement('script'); s.type = 'text/javascript'; s.src = 'https://cdneu.net/app.js';
    t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s, t);
	`;

	return (
		<Head>
			{/*<!-- Ortto Tracking Code --> */}
			<script dangerouslySetInnerHTML={{ __html: trackingCode }} />
			{/*<!-- End Ortto Tracking Code --> */}
		</Head>
	);
};
